import bdjs from "@bd-core/bdjs";
import { getSession, getSessionById } from "@bd-core/firebase-actions";
import $ from "jquery";
import { formatTime } from "../utils/formatTime";
import html2canvas from "@wtto00/html2canvas"; // Use this fork version to fix object-fit issue
import bdapi from "@bd-core/bd-api";

const FRAME_MARKER_COUNT = 10;

const buildSessionTimelineMarkers = (duration) => {
    if (!duration || duration <= 0) {
        return [];
    }

    if (FRAME_MARKER_COUNT <= 1) {
        return [duration];
    }

    const times = [];
    for (let i = 0; i < FRAME_MARKER_COUNT; i++) {
        times.push((i / (FRAME_MARKER_COUNT - 1)) * duration);
    }

    return times;
};

export const ResultPage = () => {
    const isResultPage = $("#result-page").length > 0;
    if (!isResultPage) return false;

    const urlParams = new URLSearchParams(window.location.search);
    const teamCode = urlParams.get("team-code");
    const sessionId = urlParams.get("session-id");

    if (!teamCode) return false;

    const upperTeamCode = teamCode.toUpperCase();

    let selfMarks = [];
    let teamMarks = [];

    const init = async () => {

        try {
            const sessionData = sessionId
                ? await getSessionById(upperTeamCode, sessionId)
                : await getSession(upperTeamCode);

            const session = sessionData.val();
            const bdSessionId = session.sessionId;
            const marks = session.marks;
            const accumulatedTime =
                typeof session.accumulatedTime === "number" &&
                !isNaN(session.accumulatedTime)
                    ? session.accumulatedTime
                    : 0;

            const timelineEl = $(".duration__timeline");
            timelineEl.empty();

            $(".duration__label--end .label__time").text(
                formatTime(accumulatedTime),
            );

            const [response] = await bdjs.goAsync(
                bdapi.post("game/get-session-data", {
                    session_id: bdSessionId,
                }),
            );
            const responseData = response.data.data.session;

            if (responseData.title) {
                $(".result__brand__session").text(responseData.title);
            }

            const $thumbnailsList = $(".result__thumbnails");
            const $timelineDuration = $(".duration__timeline");
            $thumbnailsList.empty();
            $timelineDuration.empty();

            const markerTimes = buildSessionTimelineMarkers(accumulatedTime);

            markerTimes.forEach((time) => {
                const timestamp = formatTime(time);
                const positionPercentage = (
                    (time / accumulatedTime) *
                    100
                ).toFixed(2);
                const $timelineMarker = $(`
                        <div class="duration__timeline__frame-marker" 
                             style="left: ${positionPercentage}%" 
                             data-timestamp="${time}"
                             title="${timestamp}">
                            <span class="frame-marker__time">${timestamp}</span>
                        </div>
                    `);
                $timelineDuration.append($timelineMarker);
            });

            if (
                responseData.scene_segments &&
                Array.isArray(responseData.scene_segments) &&
                responseData.scene_segments.length > 0
            ) {
                let totalWidth = 0;
                for (let i = 0; i < responseData.scene_segments.length; i++) {
                    let segment = responseData.scene_segments[i];
                    let widthPercentage =
                        Number(segment.width_percentage) || 10;
                    const thumbnail = segment.thumbnail || "";
                    const segmentLabel = segment.segment_label || "";

                    if (totalWidth + widthPercentage > 100) {
                        widthPercentage = 100 - totalWidth;
                        if (widthPercentage > 0) {
                            const $thumbnail = $(`
                                <li class="thumbnail" style="width: ${widthPercentage}%">
                                    <img class="thumbnail__image" src="${thumbnail}" alt="psychology" />
                                    <span class="thumbnail__label text-body">
                                        ${segmentLabel}
                                    </span>
                                </li>
                            `);
                            $thumbnailsList.append($thumbnail);
                        }
                        break;
                    } else {
                        const $thumbnail = $(`
                            <li class="thumbnail" style="width: ${widthPercentage}%">
                                <img class="thumbnail__image" src="${thumbnail}" alt="psychology" />
                                <span class="thumbnail__label text-body">
                                    ${segmentLabel}
                                </span>
                            </li>
                        `);
                        $thumbnailsList.append($thumbnail);
                        totalWidth += widthPercentage;
                        if (totalWidth === 100) break;
                    }
                }
            }

            if (marks) {
                Object.entries(marks).forEach(([, userMarks]) => {
                    if (userMarks.self) {
                        selfMarks.push(userMarks.self);
                    }
                    if (userMarks.team) {
                        teamMarks.push(userMarks.team);
                    }
                });
            }

            selfMarks.sort((a, b) => a - b);
            teamMarks.sort((a, b) => a - b);

            const $topElList = $(".timeline--top").find(".markers__list");
            const $bottomElList = $(".timeline--bottom").find(".markers__list");

            selfMarks.forEach((time) => {
                const percentage = ((time / accumulatedTime) * 100).toFixed(2);
                const $el = $(`<div class="marker" style="left: ${percentage}%">
                    <span class="marker__icon btn-tertiary">!</span>
                    <span class="marker__time text-body">${formatTime(
                        time,
                    )}</span>
                </div>`);
                $topElList.append($el);
            });

            teamMarks.forEach((time) => {
                const percentage = ((time / accumulatedTime) * 100).toFixed(2);
                const $el = $(`<div class="marker" style="left: ${percentage}%">
                    <span class="marker__icon btn-tertiary">!</span>
                    <span class="marker__time text-body">${formatTime(
                        time,
                    )}</span>
                </div>`);
                $bottomElList.append($el);
            });

            bdjs.hideLoading();
        } catch (error) {
            console.error("Error in initialization:", error);
            bdjs.hideLoading();
        }
    };

    bdjs.listen("bd__sessionInitialState", init);

    $(document).on("click", ".js-download-results", async () => {
        try {
            const $el = $(".result");
            await document.fonts.ready;
            const canvas = await html2canvas($el[0], {
                scale: 2,
                useCORS: true,
                logging: false,
            });

            const croppedCanvas = document.createElement("canvas");
            const ctx = croppedCanvas.getContext("2d");
            croppedCanvas.width = canvas.width;
            croppedCanvas.height = canvas.height - 150 * 2;
            ctx.drawImage(
                canvas,
                0,
                0,
                canvas.width,
                croppedCanvas.height,
                0,
                0,
                croppedCanvas.width,
                croppedCanvas.height,
            );

            croppedCanvas.toBlob(
                (blob) => {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `result.jpg`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                },
                "image/jpeg",
                0.95,
            );
        } catch (error) {
            console.error("Error generating download:", error);
        }
    });

    $(document).on("click", ".js-play-again", async () => {
        try {
            bdjs.showLoading();

            const [response] = await bdjs.goAsync(
                bdapi.post("/game/fully-finished-game", {
                    team_code: upperTeamCode,
                }),
            );

            if (response?.data?.success) {
                window.location.href = response.data.data.redirect;
            } else {
                console.error("Failed to create new game");
                bdjs.hideLoading();
            }
        } catch (error) {
            console.error("Error in play again:", error);
            bdjs.hideLoading();
        }
    });

    $(document).on("click", ".js-finish-game", () => {
        $(".finish-game-popup").addClass("is-open");
    });

    $(document).on(
        "click",
        ".js-cancel-finish-game, .finish-game-popup__overlay",
        () => {
            $(".finish-game-popup").removeClass("is-open");
        },
    );

    $(document).on("click", ".js-confirm-finish-game", async () => {
        try {
            $(".finish-game-popup").removeClass("is-open");
            bdjs.showLoading();

            await bdjs.goAsync(
                bdapi.post("/game/fully-finished-game", {
                    team_code: upperTeamCode,
                }),
            );

            const [response] = await bdjs.goAsync(
                bdapi.post("/game/create-new-game-session", {}),
            );

            if (response?.data?.success) {
                window.location.href = response.data.data.redirect;
            } else {
                console.error("Failed to create new game progress");
                bdjs.hideLoading();
            }
        } catch (error) {
            console.error("Error in finish game:", error);
            bdjs.hideLoading();
        }
    });
};